import ChallengeCurationDetail from './ChallengeCurationDetail';

export default ChallengeCurationDetail;
